import { EcommerceAPIApi as EcommerceApi } from '@parkingbase/ecommerce-api-demo';

import { BaseApiService } from './baseApi.service';

export class ContactUsService extends BaseApiService {
  protected contactUsApi: EcommerceApi;

  constructor() {
    super();
    this.contactUsApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getDefaultContactUs() {
    // Public endpoint — skip auth so a stale token doesn't trigger a 401.
    const response = await this.contactUsApi.defaultContactUs({ skipAuth: true });
    return response.data;
  }
}
